// **Author:** Selvadurai 
import React from "react";
import Router from "./routers/router";

export default function App() {
  return (
    <div>
      <Router />
    </div>
  );
}
